import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import './Renderer_RowWrapper.scss';
export class Renderer_RowWrapper extends ComponentSync {
    shouldComponentUpdate() {
        return true;
    }
    render() {
        const Renderer = TS_PropRenderer[this.props.direction];
        return _jsx(Renderer, { className: 'advisor-setting__row-wrapper', label: this.props.label, children: this.props.children });
    }
}
//# sourceMappingURL=Renderer_RowWrapper.js.map